/**
 * Accordion Single Open
 * 
 * Este script asegura que solo un acordeón esté abierto a la vez dentro de contenedores
 * con la clase 'accordion--caret'. Cuando se abre un acordeón, cierra automáticamente
 * cualquier otro acordeón que esté abierto en el mismo contenedor.
 */

class AccordionSingleOpen {
  constructor() {
    // Crear un WeakMap para almacenar los manejadores de eventos
    this.eventHandlers = new WeakMap();
    this.init();
  }

  init() {
    // Esperar a que el DOM esté completamente cargado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupAccordions());
    } else {
      this.setupAccordions();
    }

    // También configurar cuando el contenido cambie (para posibles cargas dinámicas)
    document.addEventListener('shopify:section:load', () => this.setupAccordions());
    document.addEventListener('shopify:block:select', () => this.setupAccordions());
  }

  setupAccordions() {
    // Encontrar todos los contenedores con la clase accordion--caret
    const accordionContainers = document.querySelectorAll('.accordion--caret');
    
    accordionContainers.forEach(container => {
      // Obtener todos los elementos accordion-custom dentro de este contenedor
      const accordionElements = container.querySelectorAll('accordion-custom');
      
      // Configurar el evento para cada acordeón
      accordionElements.forEach(accordion => {
        // Obtener el elemento details
        const details = accordion.querySelector('details');
        
        if (!details) return;
        
        // Eliminar el listener anterior si existe para evitar duplicados
        const existingHandler = this.eventHandlers.get(details);
        if (existingHandler) {
          details.removeEventListener('toggle', existingHandler);
        }
        
        // Crear un nuevo manejador de eventos
        const handler = () => {
          // Solo actuar cuando el acordeón se abre
          if (details.open) {
            // Cerrar todos los demás acordeones en este contenedor
            accordionElements.forEach(otherAccordion => {
              const otherDetails = otherAccordion.querySelector('details');
              if (otherDetails && otherDetails !== details && otherDetails.open) {
                otherDetails.open = false;
              }
            });
          }
        };
        
        // Almacenar y agregar el evento
        this.eventHandlers.set(details, handler);
        details.addEventListener('toggle', handler);
      });
    });
  }
}

// Inicializar la funcionalidad
new AccordionSingleOpen();
